import { gql } from '@apollo/client';

// Operation name must stay exactly "LogApplicationEvent" — it's on the backend's
// auth-bypass allowlist (server.ts) so anonymous visitors to /app can call it.
export const LOG_APPLICATION_EVENT = gql`
    mutation LogApplicationEvent(
        $eventType: String!
        $sessionId: String!
        $platform: String
        $code: String
        $email: String
        $detail: String
        $userAgent: String
    ) {
        logApplicationEvent(
            eventType: $eventType
            sessionId: $sessionId
            platform: $platform
            code: $code
            email: $email
            detail: $detail
            userAgent: $userAgent
        )
    }
`;
